/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionDto } from '../../models/transaction-dto';

export interface UserControllerGetTransactionByUuid$Params {
  uuid: string;
  includeUnconfirmed?: boolean;
}

export function userControllerGetTransactionByUuid(http: HttpClient, rootUrl: string, params: UserControllerGetTransactionByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionDto>> {
  const rb = new RequestBuilder(rootUrl, userControllerGetTransactionByUuid.PATH, 'get');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.query('includeUnconfirmed', params.includeUnconfirmed, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionDto>;
    })
  );
}

userControllerGetTransactionByUuid.PATH = '/user/me/transaction/{uuid}';
